import LinkMark from "@/components/shared/content/LinkMark";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

export default function MarkdownCaption({ children }: { children: string }) {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        p: ({ children: caption }) => <span>{caption}</span>,
        a: ({ href, children: label }) => (
          <LinkMark value={{ href }}>{label}</LinkMark>
        ),
        strong: ({ children: content }) => <strong>{content}</strong>,
        em: ({ children: content }) => <em>{content}</em>,
      }}
    >
      {children}
    </Markdown>
  );
}
